/**
 * 报名审核列表
 * @description 报名审核列表
 * @author mll
 * @date 2021-01-07
 */

import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool';
import './index.less'
import { reduxTemplateCofig, templateConfig } from './config'
import { WizPhoneCall, WizCallLog } from "@/containers/common";
import { seatsOut, modelUtils } from '@/utils'
import { string } from "prop-types";
const { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport, WizModal } = component_tool;


const _getValue = (type, key) => {
  const values = {
    status: {
      1: '待审核',
      2: '已通过',
      3: '未通过',
    },
    jobState: {
      0: '离职',
      1: '在职'
    }

  };
  return values[type][key]
};

class applyVerifyList extends WizContainer {

  componentName = 'applyVerifyList';

  constructor(props) {
    super(props)
    let { history } = props
    let applyInfo = {}
    if (history.location.record) {
      applyInfo = history.location.record
    }
    this.state = {
      applyInfo: applyInfo,
      callModalShow: false,
      locCallRecord: {},
      callLogShow: false,
    }
  }


  componentDidMount() {
    seatsOut({ fun: this._seatsLoginOut })
  }

  propsAndStateOnChange = {
    seatsLoginOut: this._seatsLoginOutOver.bind(this),
  }

  _seatsLoginOutOver(nextProps, nextState) {
    if (nextProps.seatsLoginOut.success && nextProps.seatsLoginOut.data) {
    } else {
      wizNotice.error(nextProps.seatsLoginOut.msg);
    }
    return true;
  }
  _seatsLoginOut = (params) => {
    ClinkAgent.setup({ sipPhone: false, debug: false }, function () {
      // 注册退出响应回调方法
      ClinkAgent.registerCallback(ClinkAgent.ResponseType.LOGOUT, function (result) {
        if (result.code === 0) {
          // 退出成功
          console.log('退出成功777')
        } else {
          // 退出失败
        }
      });
    });
    ClinkAgent.logout({ logoutMode: 1, removeBinding: 0 });
    this.doAction({
      path: 'smartPhone/seatsLoginOut',
      payload: {
        key: "seatsLoginOut",
        apiParams: {
          ...params
        }
      }
    });
  }
  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  /**
   * 查看
   */
  look = (e, applyId) => {
    this.jumpPage('push', '/workflow/applyVerify/verify', { rows: [{ ...e, mode: e && e['status'] === 1 ? 'audio' : e['status'] === 4 ? 'endAudio' : 'look' }], applyId: applyId })
  }

  _handleAuditCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    let data = o['data'];
    if (o['success']) {
      if (data && data != null && data != '' && data != undefined) {
      } else {
        data = o['msg'];
      }
      let str = data && data.replace(/<br\/>/g, "\n");
      this.changeModal(false, true, true)
      wizNotice.success({
        key: 'default',
        message: '成功',
        description: (
          <div>
            <p style={{ whiteSpace: "pre-line" }}>{str}</p>
          </div>
        ),
      })
      return true;
    } else {
      if (data && data instanceof string) {
      } else {
        data = o['msg'];
      }
      let str = data && data.replace(/<br\/>/g, "\n");
      wizNotice.error({
        key: 'default',
        message: '失败',
        description: (
          <div>
            <p style={{ whiteSpace: "pre-line" }}>{str}</p>
          </div>
        ),
      });
      return false;
    }
  }
  /**
   * 查看
   */
  look = (e) => {
    this.jumpPage('push', '/workflow/applyVerify/verify', { rows: [{ ...e, mode: e && e['status'] === 1 ? 'audio' : 'look' }] })
  }

  /**
    * 拨打电话
  */
  openCall = (record) => {
    this.setState({ callModalShow: true, locCallRecord: record })
  }

  //通话记录
  openCallLog = (record) => {
    this.setState({ callLogShow: true, locCallRecord: record ? record : {} })
  }

  /**
   * 导出
   * @param {*} nextProps
   * @param {*} nextState
   * @param {*} key
   */
  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '报名申请',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '身份证号/工号',
        field: 'idCard',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '邮箱',
        field: 'email',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织名称',
        field: 'orgName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '区域',
        field: 'areaName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职状态',
        field: 'jobState',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '报名名称',
        field: 'applyName',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '计划安排名称',
        field: 'planName',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '审核状态',
        field: 'status',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '报名提交时间',
        field: 'applySubmitTime',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '申请人账号',
        field: 'applicantUserName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '申请人姓名',
        field: 'applicantFullName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '报名时间',
        field: 'applyDate',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (o['success']) {
      let data = Object.assign([], o['data'])
      data.forEach((val, index) => {
        val['status'] = _getValue('status', val['status'])
        val['jobState'] = _getValue('jobState', val['jobState'])
        val['applyDate'] = val['applyStartTime'] + '~' + val['applyEndTime']
      })
      WizBrowserExport({
        title: '报名申请',
        sheetName: '报名申请',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '报名申请.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  closeModal = () => {
    this.setState({ callModalShow: false })
  }
  // jumpQueDetail = (item) => {
  //   const { info } = this.props;
  //   let pageList = getPageData(info && info.data)
  //   let record = pageList.list.find(x => x.id == item.entityId)
  //   this.jumpPage('push', '/biz/survey/surveyRecordInfo/surveyRecordInfoDetail', record, this._surveyId)
  // }
  _render() {
    let { applyInfo } = this.state
    let { callModalShow, locCallRecord, callLogShow } = this.state
    if (applyInfo && applyInfo.id) {
      params = { applyName: applyInfo.name, applyId: applyInfo.id }
    }
    let params = { applyName: this.props.history.location.record?.name || '', status: 1 }
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({ look: this.look, onDo: this, params }),
      apiDataFormat: {
        delete: this._handleCMD.bind(this),
        export: this._handleFile,
        batchAudit: this._handleAuditCMD.bind(this),
      },
      params
    })
    return <>
      <WizReduxTemplate {..._reduxTemplateCofig} />
      {callModalShow ? <WizPhoneCall callScene={1} entityType={2} modalShow={callModalShow} record={locCallRecord}
        closeModal={() => this.setState({ callModalShow: false })} /> : null}
      <WizModal title='通话记录' destroyOnClose={true} visible={callLogShow} footer={null} onCancel={() => this.setState({ callLogShow: false })} width={850}>
        <WizCallLog entityType={2} entityId={locCallRecord.id} applySurveyId={locCallRecord.entityId} entityTypeNew={7}
        //  jumpDetail={this.jumpQueDetail}
        />
      </WizModal>
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { smartPhone } = state;
  const seatsLoginOut = modelUtils.getModelEntity(smartPhone, 'seatsLoginOut');

  return {
    seatsLoginOut
  }
};

export default connect(mapStateToProps)(applyVerifyList);
